import { tv } from "tailwind-variants";

import { Spinner } from "./spinner";

const screenSpinnerVariants = tv({
  base: "flex size-full flex-1 items-center justify-center self-center justify-self-center pt-16",
});

type ScreenSpinnerProps = {
  className?: string;
};

export const ScreenSpinner = ({ className }: ScreenSpinnerProps) => {
  return (
    <div className={screenSpinnerVariants({ className })}>
      <Spinner className="mr-3" />
    </div>
  );
};
